"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardMLSFooter = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardMLSFooterMixin = require("../../mixins/components/PropertyCardMLSFooterMixin");
var StyledPropertyCardMLSFooter = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardMLSFooter",
  componentId: "c11n-8-107-0__sc-nrh0so-0"
})(["", ""], _PropertyCardMLSFooterMixin.PropertyCardMLSFooterMixin);
exports.StyledPropertyCardMLSFooter = StyledPropertyCardMLSFooter;